import { Component, OnInit } from '@angular/core';
import { AsistenteServicesService } from '../../services/asistente-services.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { HelpersService } from '../../../shared/servicio/helpers/helpers.service';

@Component({
  selector: 'app-premios',
  templateUrl: './premios.component.html',
  styleUrls: ['./premios.component.css'],
})
export class PremiosComponent implements OnInit {
  prizes: any[] = [];
  points: any;
  showLoading = true;
  redeemingId: string = null;
  showTermsModal: boolean = false;
  selectedPrizeTerms: string = '';
  selectedPrizeIdForModal: string = null;

  // Selección por pasos: 1=zona, 2=ciudad, 3=sede, 4=términos
  currentStep: number = 1;
  zones: any[] = [];
  cities: any[] = [];
  sites: any[] = [];
  selectedBrandId: any = null;
  selectedZoneId: any = null;
  selectedCityId: any = null;
  selectedSiteId: any = null;
  loadingOptions: boolean = false;

  constructor(
    public _asistente: AsistenteServicesService,
    private _http: HttpClient,
    public router: Router,
    public dash: DashboardComponent,
    public helper: HelpersService
  ) {}

  ngOnInit() {
    this.prize();
    this.user();
  }

  user() {
    this._http.get(environment.Api_get_user).subscribe(
      (data) => {
        this.points = data['points'];
      },
      (error) => {
        console.log(error);
      }
    );
  }

  prize() {
    this._asistente.prize().subscribe(
      (data) => {
        this.prizes = data['rewards']['data'] || [];
        this.showLoading = false;
      },
      (error) => {
        console.log(error);
        this.showLoading = false;
      }
    );
  }

  // rewardId = UUID del premio  →  va en el body del redeem
  // brandId  = p.external_config.brand_id  →  primer param de zona/ciudad/sede
  openRedeemModal(rewardId: string, brandId: any, terms: string) {
    this.selectedPrizeIdForModal = rewardId;
    this.selectedBrandId = brandId;
    this.selectedPrizeTerms = terms;
    this.currentStep = 1;
    this.showTermsModal = true;
    this.loadingOptions = true;
    this.zones = [];
    this._asistente.getZonesDirect(brandId).subscribe(
      (data: any) => {
        this.zones = Array.isArray(data) ? data : (data.zones || data.data || []);
        this.loadingOptions = false;
      },
      (error) => {
        console.log(error);
        this.loadingOptions = false;
      }
    );
  }

  onSelectZone(zone: any) {
    this.selectedZoneId = zone.zone_id || zone.id;
    this.currentStep = 2;
    this.loadingOptions = true;
    this.cities = [];
    this._asistente.getCitysDirect(this.selectedBrandId, this.selectedZoneId).subscribe(
      (data: any) => {
        this.cities = Array.isArray(data) ? data : (data.cities || data.data || []);
        this.loadingOptions = false;
      },
      (error) => {
        console.log(error);
        this.loadingOptions = false;
      }
    );
  }

  onSelectCity(city: any) {
    this.selectedCityId = city.city_id || city.id;
    this.currentStep = 3;
    this.loadingOptions = true;
    this.sites = [];
    this._asistente.getSitesDirect(this.selectedBrandId, this.selectedZoneId, this.selectedCityId).subscribe(
      (data: any) => {
        this.sites = Array.isArray(data) ? data : (data.sites || data.data || []);
        this.loadingOptions = false;
      },
      (error) => {
        console.log(error);
        this.loadingOptions = false;
      }
    );
  }

  onSelectSite(site: any) {
    this.selectedSiteId = site.site_id || site.id;
    this.currentStep = 4;
  }

  goBack() {
    if (this.currentStep === 2) {
      this.currentStep = 1;
      this.selectedZoneId = null;
      this.cities = [];
    } else if (this.currentStep === 3) {
      this.currentStep = 2;
      this.selectedCityId = null;
      this.sites = [];
    } else if (this.currentStep === 4) {
      this.currentStep = 3;
      this.selectedSiteId = null;
    }
  }

  confirmRedemption() {
    if (!this.selectedPrizeIdForModal || !this.selectedSiteId) {
      console.error('Faltan datos para completar la redención.');
      return;
    }
    this.redeemingId = this.selectedPrizeIdForModal;
    this._asistente.redeem(this.selectedPrizeIdForModal, this.selectedBrandId, this.selectedSiteId).subscribe(
      (_) => {
        this.redeemingId = null;
        this.helper.modalSuccess('¡Redención exitosa!');
        this.dash.user();
        this.closeRedeemModal();
      },
      (error) => {
        this.redeemingId = null;
        const errBody = error.error;
        const errorMsg =
          (errBody && errBody.error) ||
          (errBody && errBody.message) ||
          'Error en la transacción';
        this.helper.modalError(errorMsg);
        this.closeRedeemModal();
      }
    );
  }

  closeRedeemModal() {
    this.showTermsModal = false;
    this.selectedPrizeTerms = '';
    this.selectedPrizeIdForModal = null;
    this.currentStep = 1;
    this.zones = [];
    this.cities = [];
    this.sites = [];
    this.selectedBrandId = null;
    this.selectedZoneId = null;
    this.selectedCityId = null;
    this.selectedSiteId = null;
    this.loadingOptions = false;
  }
}
